module.exports = __webpack_public_path__ + "static/media/external-link-icon-white.abf14809.svg";